import React from 'react';
/*
 * Bronson Hr component.
 */
export function Hr({ testId, ...otherProps }) {
    return React.createElement("hr", { ...otherProps, "data-testid": testId });
}
